// extracted by mini-css-extract-plugin
export default {"list":"others-like-you_list__DRnAh","arrow_icon":"others-like-you_arrow_icon__gr9us","subtitle":"others-like-you_subtitle__8zXZu"};